import viMessagesRaw from '../locales/vi_VN.extracted.json';

// Transform { id: { message: "..." } } to { id: "..." }
const viMessages = Object.keys(viMessagesRaw).reduce((acc, key) => {
  acc[key] = (viMessagesRaw as any)[key].message;
  return acc;
}, {} as Record<string, string>);

const ViLang = {
  messages: viMessages,
  locale: 'vi-VN',
};

export default ViLang;
